import * as React from "react";
import {
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import { IPendingCustomer } from "src/core/pending-customers/api/pendingCustomer.api";
import AssignedUser from "src/library/components/AssignedUser/AssignedUser";

/**
 * This function returns a reusable formated column definition for pending customer assigned column to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition
 */
export const pendingCustomerAssignedColumn = <TData extends IPendingCustomer>(
  columnHelper: ColumnHelper<TData>,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "cell">>
) => {
  const accessor = "assignedUser" as DeepKeys<TData>;

  return columnHelper.accessor(accessor, {
    id: column.id ? column.id : accessor,
    header: () => (
      <Text
        weight="bold"
        style={{ verticalAlign: "center" }}
      >
        {column.header ? column.header.toString() : typeof accessor === "string" ? accessor : ""}
      </Text>
    ),
    cell: column.cell ? column.cell : info => {
      const pendingCustomer = info.row.original;

      return (
        <AssignedUser
          rowId={pendingCustomer.id}
          user={pendingCustomer.assignedUser}
          groupName={pendingCustomer.userGroup?.name}
        />
      );
    },
    enableSorting: false
  } as DisplayColumnDef<TData>);
};